<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Адрес электронной почты
        .form-elem__main
          .input {{ email }}
          .form-elem__description На этот адрес будут приходить последние новости и уведомления о статусе вашей заявки. Вы можете изменить его в настройках аккаунта.
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : errorFieldPhone }"
      )
        .form-elem__title Телефон ребенка
        .form-elem__main
          input.input(
            type="tel"
            v-model="localPhone"
            @input="resetError('phone')"
            maxlength="17"
            v-mask="'+7(###)-###-##-##'"
          )
    .form__elem(
      v-if="!isAccompanying"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : errorFieldParentName}"
      )
        .form-elem__title ФИО родителя
        .form-elem__main
          input.input(
            type="text"
            v-model="localParentName"
            @input="resetError('parent_name')"
            maxlength="256"
          )

    .form__elem(
      v-if="!isAccompanying"
    )
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : errorFieldParentsPhone}"
      )
        .form-elem__title Контактный телефон родителя
        .form-elem__main
          input.input(
          type="tel"
          v-model="localParentsPhone"
          @input="resetError('parents_phone')"
          maxlength="17"
          v-mask="'+7(###)-###-##-##'"
          )
</template>

<script>
export default {
  name: "form-contacts",
  props: {
    email: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    parentName: {
      type: String,
      default: "",
    },
    parentsPhone: {
      type: String,
      default: "",
    },
    resetError: {
      type: Function,
      default: () => {},
    },
    fieldsErrors: {
      type: Object,
      default: () => ({}),
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localPhone: {
      get() {
        return this.phone;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "phone"]);
      },
    },
    localParentName: {
      get() {
        return this.parentName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "parent_name"]);
      },
    },
    localParentsPhone: {
      get() {
        return this.parentsPhone;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "parents_phone"]);
      },
    },
    errorFieldPhone() {
      return (
        this.fieldsErrors.incorrect_phone.value ||
        this.fieldsErrors.empty_phone.value
      );
    },
    errorFieldParentsPhone() {
      return (
        this.fieldsErrors.incorrect_parents_phone.value ||
        this.fieldsErrors.empty_parents_phone.value
      );
    },
    errorFieldParentName() {
      return this.fieldsErrors.parent_name.value;
    },
  },
};
</script>
